import { Injectable } from '@angular/core';
import { MaterialComponent } from '../../interfaces/iMaterialComponent';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class ComponentLibraryService {
  private materialComponents: MaterialComponent[] = [
    {
      name: 'Button',
      shortcode: 'mat-button',
      template: '<button class="mdc-button mat-mdc-button" mat-button><span class="mdc-button__label">{{text}}</span></button>',
      defaultText: 'Click me',
      properties: {
        events: ['click', 'focus', 'blur'],
        inputs: ['color', 'disabled'],
        text: 'Button Text'
      }
    },
    {
      name: 'Raised Button',
      shortcode: 'mat-raised-button',
      template: '<button class="mdc-button mdc-button--raised mat-mdc-raised-button" mat-raised-button><span class="mdc-button__label">{{text}}</span></button>',
      defaultText: 'Click me',
      properties: {
        events: ['click', 'focus', 'blur'],
        inputs: ['color', 'disabled'],
        text: 'Button Text'
      }
    },
    {
      name: 'Icon Button',
      shortcode: 'mat-icon-button',
      template: '<button class="mdc-icon-button mat-mdc-icon-button" mat-icon-button><span class="mat-mdc-button-touch-target"><mat-icon>{{text}}</mat-icon></span></button>',
      defaultText: 'home',
      properties: {
        events: ['click'],
        inputs: ['color'],
        text: 'Icon Name'
      }
    }
  ];

  private eventHandlers = new Map<string, (event: Event) => void>();

  constructor(private sanitizer: DomSanitizer) {
    this.registerEventHandler('handler_jkvte7b1m', function(event: Event) {
      window.alert('Handler executed');
    });
  }

  getComponents(): MaterialComponent[] {
    return this.materialComponents;
  }

  registerEventHandler(id: string, handler: (event: Event) => void) {
    this.eventHandlers.set(id, handler);
  }

  getEventHandler(id: string): ((event: Event) => void) | undefined {
    return this.eventHandlers.get(id);
  }

  generateShortcode(name: string, properties: {[key: string]: string}): string {
    const component = this.materialComponents.find(c => c.name === name);
    if (!component) return '';

    let shortcode = `[${component.shortcode}`;
    
    // Add text content
    const text = properties['text'] || component.defaultText;
    shortcode += ` text="${text}"`;
    
    // Add event handlers
    Object.entries(properties).forEach(([key, value]) => {
      if (key.startsWith('(')) {
        const handlerId = `handler_${Math.random().toString(36).substr(2, 9)}`;
        this.registerEventHandler(handlerId, () => {
          window.alert(value);
        });
        shortcode += ` data-handler-id="${handlerId}"`;
      }
    });

    shortcode += ']';
    return shortcode;
  }

  processShortcodes(content: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(content.replace(
      /\[(mat-[^\]]+)\]/g,
      (match, shortcode) => {
        const [shortcodeName, ...attributes] = shortcode.split(' ');
        const component = this.materialComponents.find(c => c.shortcode === shortcodeName);
        if (!component) return match;

        // Parse attributes
        const attrs = new Map<string, string>();
        attributes.forEach((attr: string) => {
          const [key, value] = attr.split('=');
          if (key && value) {
            attrs.set(key, value.replace(/"/g, ''));
          }
        });

        // Replace template placeholders
        let html = component.template;
        if (attrs.has('text')) {
          html = html.replace('{{text}}', attrs.get('text')!);
        }
        
        // Add handler ID if present
        const handlerId = attrs.get('data-handler-id');
        if (handlerId) {
          html = html.replace('<button', `<button data-handler-id="${handlerId}"`);
        }

        return html;
      }
    ));
  }
}
